import React from 'react'

import axios from 'axios'
import Config from '../Helpers/Config';
import Loader from '../Components/Loader';
import {NotificationManager} from '../Helpers/NotificationManager';;
import {locale} from '../locale/AppLocale'
import {ImageUrl} from '../Helpers/ImageUrl'

import Select from 'react-select'

// import 'react-select/dist/react-select.css';
// import 'react-virtualized/styles.css'
// import 'react-virtualized-select/styles.css'

import {Link} from 'react-router-dom'

import InfiniteScroll from 'react-infinite-scroller';
import {GetEntityAttribute} from "../Helpers/Entity";

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

export default class UploadListing extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            data: [],
            bulk: {},
            handlingTimes: [],
            productConditions: [],
            shippingDeliveryOptionsList: [],
            props: {},
            formParams: {},
            pagination:{
                page:0,
                pages:0
            },
            is_loading:false
        }
        this.onHandlingTimeChange = this.onHandlingTimeChange.bind(this)
        this.onProductConditionChange = this.onProductConditionChange.bind(this)
        this.onCheckboxChange = this.onCheckboxChange.bind(this)
        this.loadMore = this.loadMore.bind(this)
    }

    render() {

        return (
            <div className="products-bulk-upload--listing container">

                <div>
                    <div className="input-c form-field">
                        <label>{locale.get('handling_time')}</label>
                        <div className="form-field--input">
                            <Select
                                options={this.state.handlingTimes.map(item => ({
                                    value: item.id,
                                    label: GetEntityAttribute(item,'title_ar')
                                }))}
                                value={this.state.formParams.handling_time}
                                keepOpen={false}
                                onChange={this.onHandlingTimeChange}
                                simpleValue={true}
                                placeholder={locale.get('choose')}/>
                        </div>
                    </div>


                </div>

                <div>
                    <div className="input-c form-field">
                        <label>{locale.get('product_condition')}</label>
                        <div className="form-field--input">
                            <Select
                                options={this.state.productConditions.map(item => ({
                                    value: item.id,
                                    label: GetEntityAttribute(item,'title_ar')
                                }))}
                                value={this.state.formParams.pcondition}
                                keepOpen={false}
                                onChange={this.onProductConditionChange}
                                simpleValue={true}
                                placeholder={locale.get('choose')}/>
                        </div>
                    </div>


                </div>

                {/*<div>*/}
                {/*    <div className="input-c form-field">*/}
                {/*        <label>{locale.get('shipping_delivery_option')}</label>*/}
                {/*        <div className="form-field--input">*/}
                {/*            <Select*/}
                {/*                options={this.state.shippingDeliveryOptionsList.map(item => ({*/}
                {/*                    value: item.id,*/}
                {/*                    label: GetEntityAttribute(item,'title_ar')*/}
                {/*                }))}*/}
                {/*                value={this.state.formParams.shipping_delivery_option}*/}
                {/*                keepOpen={false}*/}
                {/*                onChange={this.onShippingDeliveryOptionChange}*/}
                {/*                simpleValue={true}*/}
                {/*                placeholder={locale.get('choose')}/>*/}
                {/*        </div>*/}
                {/*    </div>*/}


                {/*</div>*/}

                <InfiniteScroll
                    pageStart={0}
                    initialLoad={false}
                    loadMore={this.loadMore}
                    hasMore={this.state.pagination.page < this.state.pagination.pages}
                    loader={<div><Loader completed={this.state.is_loading === false}/></div>}
                >
                    {
                        this.state.data.map((item) => (
                            <Product
                                businessSlug={this.props.match.params.businessSlug}
                                formParams={this.state.formParams}
                                key={item.id}
                                product={item}
                                bulk={this.state.bulk}
                                props={this.state.props}/>
                        ))
                    }
                </InfiniteScroll>
            </div>
        );
    }

    componentDidMount() {
        this.loadMore()
    }


    loadMore(){
        if(this.state.is_loading){
            return
        }
        this.setState({
            is_loading:true
        })
        axios.post(Config.api(`products/bulk-upload/products/${this.props.match.params.id}`), {
            products: true,
            page:this.state.pagination.page + 1
        }, {
            withCredentials: Config.withCredentials()
        }).then((response) => {
            this.setState({
                data: [...this.state.data,...response.data.results],
                props: response.data.props,
                bulk: response.data.bulk,
                handlingTimes: response.data.handling_times,
                shippingDeliveryOptionsList: response.data.shipping_delivery_options_list,
                productConditions: response.data.product_conditions,
                pagination:response.data.pagination,
                is_loading:false
            })
        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                if (error.response && error.response.data && error.response.data.message) {
                    NotificationManager.error(error.response.data.message);
                }
            }
            this.setState({uploading: false});
        })
    }


    onHandlingTimeChange(value) {
        this.setState({
            formParams: {
                ...this.state.formParams,
                handling_time: value,
            }
        })
    }
    onProductConditionChange(value) {
        this.setState({
            formParams: {
                ...this.state.formParams,
                pcondition: value,
            }
        })
    }

    onShippingDeliveryOptionChange(value) {
        this.setState({
            formParams: {
                ...this.state.formParams,
                shipping_delivery_option: value,
            }
        })
    }


    onCheckboxChange(el) {
        this.setState({
            formParams: {
                ...this.state.formParams,
                [el.target.name]: el.target.checked ? 1 : 0
            }
        })
    }


}


class Product extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            product_sold: null,
            status: 1,
            saving: false
        }
    }

    render() {
        let {product, props} = this.props
        return (
            <div>

                <div className="bulk-upload--preview">
                    <ImageTag product={product}/>
                    <div className="products-bulk-upload--desc">
                        <h1>{product.title}</h1>
                        <div className="products-list--props">

                            {
                                product.data.price &&
                                <Prop key="price" title={locale.get('price')} value={product.data.price}/>
                            }

                            {
                                product.data.quantity &&
                                <Prop key="quantity" title={locale.get('quantity')} value={product.data.quantity}/>
                            }

                            {
                                Object.keys(props).map((id) => {
                                    if (product.data[id]) {
                                        return <Prop key={id} title={props[id]} value={product.data[id]}/>
                                    }
                                    return null
                                })
                            }
                        </div>
                    </div>

                    <div>
                        {
                            (
                                parseInt(product.status, 10) === 2 ||
                                parseInt(this.state.status, 10) === 2
                            ) &&
                            <button className="btn-5--disabled" style={{height: 45}}>
                                <span>{locale.get('sold')}</span>
                            </button>
                        }
                        {
                            (
                                parseInt(product.status, 10) !== 2 &&
                                parseInt(this.state.status, 10) !== 2
                            ) &&
                            <Link
                                to={`/${this.props.businessSlug}/create/${this.props.bulk.payload.category_id}?bulk=${product.id}`}>
                                <button className="btn-4" style={{height: 45}}>
                                    <span>{locale.get('add_product')}</span>
                                </button>
                            </Link>
                        }

                    </div>

                </div>
                {
                    product.products.length > 0 &&
                    <div className="products-bulk-upload--list">
                        <div className="products-bulk-upload--suggestions">
                            {locale.get('suggested_products')}
                        </div>
                        {
                            product.products.map((matched) => (
                                <div key={matched.id} className="bulk-upload--preview bulk-upload--sub-preview">
                                    <div className="products-bulk-upload--image">
                                        <img src={ImageUrl(matched.image)}/>
                                    </div>
                                    <div className="products-bulk-upload--desc">
                                        <h1>{GetEntityAttribute(matched,'title')}</h1>
                                        <div className="products-list--props">
                                            {
                                                matched.attributes.map((attr) => (
                                                    attr.attributes.map((attr) => {

                                                        if (attr.value_text) {
                                                            return (
                                                                <Prop key={GetEntityAttribute(attr,'title')} title={GetEntityAttribute(attr,'title')}
                                                                      value={GetEntityAttribute(attr,'value_text')}/>
                                                            )
                                                        }

                                                        return null

                                                    })
                                                ))
                                            }
                                        </div>
                                    </div>
                                    {
                                        (
                                            parseInt(product.status, 10) === 2 ||
                                            parseInt(this.state.status, 10) === 2
                                        ) &&
                                        (
                                            product.product_sold === matched.id ||
                                            this.state.product_sold === matched.id
                                        ) &&
                                        <button className="btn-5--disabled" style={{height: 45}}>
                                            <span>{locale.get('sold')}</span>
                                        </button>
                                    }

                                    {
                                        (
                                            parseInt(product.status, 10) !== 2 &&
                                            parseInt(this.state.status, 10) !== 2
                                        ) &&
                                        <button
                                            disabled={this.state.saving}
                                            className="btn-2" onClick={() => {
                                            this.sell(matched.id)
                                        }} style={{height: 45}}>
                                            {
                                                this.state.saving === true && this.state.product_sold === matched.id
                                                && <Loader completed={false}/>
                                            }

                                            {
                                                this.state.saving === true &&
                                                this.state.product_sold === matched.id &&
                                                <span>{locale.get('selling')}</span>
                                            }
                                            {
                                                this.state.saving === true &&
                                                this.state.product_sold !== matched.id &&
                                                <span>{locale.get('sell')}</span>
                                            }


                                            {
                                                this.state.saving === false &&
                                                <span>{locale.get('sell')}</span>
                                            }
                                        </button>
                                    }
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        )
    }


    sell(matchId) {

        if (this.props.formParams.handling_time === undefined) {
            NotificationManager.error(locale.get('required', {field: locale.get('handling_time')}));
            return
        }
        if (this.props.formParams.pcondition === undefined) {
            NotificationManager.error(locale.get('required', {field: locale.get('pcondition')}));
            return
        }
        // if (this.props.formParams.shipping_delivery_option === undefined) {
        //     NotificationManager.error(locale.get('required', {field: locale.get('shipping_delivery_option')}));
        //     return
        // }

        this.setState({
            product_sold: matchId,
            saving: true
        });

        axios.post(Config.api(`products/bulk-upload/sell/${this.props.product.id}/${matchId}`), this.props.formParams, {
            withCredentials: Config.withCredentials()
        }).then((response) => {

            this.setState({
                product_sold: matchId,
                saving: false,
                status: 2
            });

        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                if (error.response && error.response.data && error.response.data.message) {
                    NotificationManager.error(error.response.data.message);
                }
            }
            this.setState({uploading: false});
        });

    }
}

const ImageTag = ({product}) => {
    if (product.data.image && Array.isArray(product.data.image) && product.data.image.length) {
        return <img alt="" src={ImageUrl(product.data.image[0])}/>
    }
    return null
}
const Prop = ({title, value}) => (
    <div className="products-list--prop">
        <strong className="products-list--prop-name">{title}</strong>
        <span className="products-list--prop-value">{value}</span>
    </div>
)